// Shared classification of API rejections.
//
// BaseApi rejects with `missingToken: true` when there is no access token to send: the user is
// signed out, the session expired, or a logout/sign-in redirect is already under way. In every one
// of those cases the page is about to navigate away and the user cannot act on the message, so
// error toasts skip it rather than flashing one per in-flight request. Note this is NOT a 401/403
// from the backend - those are real answers about a real token and still surface normally.
// Logging is deliberately left alone; only the user-facing toast is suppressed.
export const isMissingTokenError = (error) => error?.missingToken === true;
